'use client'

import { useSyncExternalStore } from 'react'
import { buildScheduleRedirectUrl, PAID_MEDIA_CALENDLY_URL } from '~/utils/ctas'
import { hasLeadMagnetUnlockCookie } from '~/utils/lead-magnet-unlock'
import { ONTRACK_UNLOCK_MAGNET } from './unlock-magnet'

/** Post-unlock CTAs skip /schedule_form (the visitor just submitted it) and go straight to Calendly, as on Coast. */
export const ONTRACK_CALENDLY_HREF = buildScheduleRedirectUrl(PAID_MEDIA_CALENDLY_URL, {})

let unlockedThisSession = false
const listeners = new Set<() => void>()

/** Covers browsers that drop the unlock cookie, and re-renders sections outside the calculator. */
export function markOnTrackUnlocked() {
  unlockedThisSession = true
  listeners.forEach((notify) => notify())
}

function subscribe(notify: () => void) {
  listeners.add(notify)
  return () => listeners.delete(notify)
}

export function useOnTrackUnlocked(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => unlockedThisSession || hasLeadMagnetUnlockCookie(ONTRACK_UNLOCK_MAGNET.slug),
    () => false
  )
}
